<template>
  <div :class="ns.b()">
    <div v-if="hasAvatar" :class="ns.b('avatar')">
      <img v-if="avatar" :src="avatar" alt="comment-avatar" />
      <slot v-else name="avatar" />
    </div>
    <div :class="ns.b('inner')">
      <div :class="ns.b('inner-content')">
        <div
          v-if="hasAuthor || hasDatetime"
          :class="[
            ns.b('title'),
            ns.b('title-align-' + computedAlign.datetime),
          ]"
        >
          <span v-if="hasAuthor" :class="ns.b('author')">
            <span v-if="author"> {{ author }} </span>
            <slot v-else name="author" />
          </span>
          <span v-if="hasDatetime" :class="ns.b('datetime')">
            <span v-if="datetime"> {{ datetime }} </span>
            <slot v-else name="datetime" />
          </span>
        </div>
        <div v-if="hasContent" :class="ns.b('content')">
          <span v-if="content"> {{ content }} </span>
          <slot v-else name="content" />
        </div>
        <div
          v-if="$slots.actions"
          :class="[
            ns.b('actions'),
            ns.b(`actions-align-${computedAlign.actions}`),
          ]"
        >
          <slot name="actions" />
        </div>
      </div>
      <div v-if="$slots.default" :class="ns.b('inner-comment')">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import { useNamespace } from '@lit-element/hooks'
import { isString } from '@lit-element/utils'

defineOptions({ name: 'LtComment' })
const props: any = defineProps({
  author: String, // 作者名
  avatar: String, // 头像
  content: String, // 评论内容
  datetime: String, // 时间描述
  // 靠左/靠右 展示 datetime 和 actions
  align: {
    type: [String, Object],
    default: 'left',
  },
})

const ns = useNamespace('comment')
const slots = useSlots()

const [hasAuthor, hasAvatar, hasContent, hasDatetime] = [
  'author',
  'avatar',
  'content',
  'datetime',
].map((propName) => computed(() => Boolean(props[propName] || slots[propName])))

const computedAlign = computed(() => {
  const { align } = props
  return {
    ...(isString(align)
      ? {
          datetime: align,
          actions: align,
        }
      : align),
  }
})
</script>
